<template>
  <base-table-row>
    <base-table-cell>
      <div>
        {{ spiderJob.id }}
      </div>
    </base-table-cell>
    <base-table-cell>
      <div>
        {{ spiderJob.status }}
      </div>
    </base-table-cell>
    <base-table-cell>
      <div>
        {{ createdAt }}
      </div>
    </base-table-cell>
    <base-table-cell>
      <div>
        {{ user }}
      </div>
    </base-table-cell>
    <base-table-cell>
      <div>
        {{ crawlStart }}
      </div>
    </base-table-cell>
    <base-table-cell>
      <div>
        {{ crawlEnd }}
      </div>
    </base-table-cell>
    <base-table-cell>
        <div class="grid grid-cols-2 gap-1">
            <div class="flex flex-col">
              <div class="my-0.5">
                  Crawl Size: {{ spiderJob.crawl_size  }}
              </div>
              <div class="my-0.5">
                  Total Crawled: {{ spiderJob.websites_crawled }}
              </div>
            </div>
            <div class="flex flex-col">
              <div class="my-0.5">
                  Successes: {{ spiderJob.successful_crawls }}
              </div>
              <div class="my-0.5">
                  Failures: {{ spiderJob.failed_crawls }}
              </div>
            </div>

        </div>
    </base-table-cell>
  </base-table-row>
</template>

<script setup>
// imports

import { defineProps, computed } from "vue";
import { formatDateWithMinutes } from "@/composables/formatDate";

// constants/variables

const props = defineProps(['spiderJob']);

// computed values

const user = computed(() => {
  if (props.spiderJob.created_by) {
    return props.spiderJob.created_by.first_name + " " + props.spiderJob.created_by.last_name;
  } else {
    return "--";
  }
});

const createdAt = computed(() => {
  return formatDateWithMinutes(props.spiderJob.created_at);
});

const crawlStart = computed(() => {
  return formatDateWithMinutes(props.spiderJob.crawl_start);
});

const crawlEnd = computed(() => {
  return formatDateWithMinutes(props.spiderJob.crawl_end);
});

const crawlSize = computed(() => {
  return props.spiderJob.crawl_size ? props.spiderJob.crawl_size : 0
});

</script>
